import { createAction, props } from '@ngrx/store';

export const sendAddAsProspect = createAction(
  '[Add as Prospect] Send Add As Prospect',
  props<{ candidateId: number; jobId: number }>(),
);

export const sendAddAsProspectSuccess = createAction(
  '[Add as Prospect] Send Add As Prospect Success',
);

export const sendAddAsProspectFail = createAction(
  '[Add as Prospect] Send Add As Prospect Fail',
  props<{ error: string; status: number }>(),
);
